import { Link } from 'react-router-dom';

const AVATAR_1 = "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20athletic%20man%20in%20his%20thirties%20wearing%20a%20white%20t-shirt%2C%20warm%20studio%20lighting%2C%20clean%20cream%20background%2C%20confident%20friendly%20smile%2C%20editorial%20portrait&width=80&height=80&seq=avatar-h1-v3-2026x&orientation=squarish";
const AVATAR_2 = "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20stylish%20woman%20with%20wavy%20hair%20in%20a%20beige%20blazer%2C%20bright%20natural%20lighting%2C%20clean%20off-white%20background%2C%20genuine%20warm%20smile%2C%20modern%20editorial%20portrait&width=80&height=80&seq=avatar-h2-v3-2026x&orientation=squarish";
const AVATAR_3 = "https://readdy.ai/api/search-image?query=Headshot%20portrait%20of%20a%20trendy%20young%20man%20with%20styled%20hair%20in%20a%20denim%20jacket%2C%20warm%20afternoon%20window%20light%2C%20neutral%20beige%20background%2C%20relaxed%20approachable%20expression%2C%20editorial%20style&width=80&height=80&seq=avatar-h3-v3-2026x&orientation=squarish";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20fashion%20editorial%20display%20with%20designer%20clothing%20items%20in%20warm%20terracotta%20cream%20and%20olive%20tones%20artistically%20arranged%20on%20a%20textured%20linen%20backdrop%2C%20dramatic%20natural%20side%20lighting%2C%20high-end%20magazine%20aesthetic%2C%20elegant%20sophisticated%20composition&width=1800&height=900&seq=hero-bg-v3-2026x&orientation=landscape"
          alt="Mulebuy Spreadsheet fashion product showcase"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1440px] px-4 md:px-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10 md:gap-16 py-16 md:py-24 pt-[80px] md:pt-[90px]">
          <div className="flex-1 max-w-[680px]">
            <div className="flex items-center gap-3 mb-6">
              <div className="flex -space-x-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-white overflow-hidden flex-shrink-0">
                  <img src={AVATAR_1} alt="Trusted buyer" className="w-full h-full object-cover" />
                </div>
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-white overflow-hidden flex-shrink-0">
                  <img src={AVATAR_2} alt="Trusted buyer" className="w-full h-full object-cover" />
                </div>
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-white overflow-hidden flex-shrink-0">
                  <img src={AVATAR_3} alt="Trusted buyer" className="w-full h-full object-cover" />
                </div>
              </div>
              <span className="text-white/90 text-sm md:text-base font-medium">Trusted by 10,000+ Smart Buyers</span>
            </div>

            <h1 className="text-white text-[3rem] md:text-[5.5rem] leading-[1.05] font-heading font-bold mb-4">
              Mulebuy<br />
              <span className="font-light italic">Spreadsheet</span>
            </h1>
            <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-[540px] mb-8">
              The ultimate comparison and buying intelligence hub. Discover how the Mulebuy spreadsheet system helps thousands of buyers compare products, agents, and sourcing options in one structured dashboard.
            </p>

            <Link
              to="/mulebuy-spreadsheet-complete-guide"
              className="inline-flex items-center gap-3 px-7 py-4 rounded-full bg-background-50 text-foreground-950 text-base font-semibold cursor-pointer hover:bg-white hover:scale-[1.02] transition-all whitespace-nowrap"
            >
              Explore Comparison Hub
              <span className="w-7 h-7 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </Link>
          </div>

          <div className="hidden lg:block flex-1"></div>
        </div>
      </div>
    </section>
  );
}